import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-links-container">
        <div className="footer-columns-container">
          <div className="footer-column">
            <span className="footer-heading">Product</span>
            <span 
              className="footer-link cursor-pointer"
              onClick={() => {
                window.location.href = '/#features';
              }}
            >
              Features
            </span>
            <span 
              className="footer-link cursor-pointer"
              onClick={() => window.location.href = '/partners'}
            >
              Partners
            </span>
            <span className="footer-link">FAQ</span>
          </div>
          <div className="footer-column">
            <span className="footer-heading">Company</span>
            <span 
              className="footer-link cursor-pointer"
              onClick={() => window.location.href = '/about'}
            >
              About us
            </span>
            <span 
              className="footer-link cursor-pointer"
              onClick={() => window.location.href = '/careers'}
            >
              Careers
            </span>
            <span 
              className="footer-link cursor-pointer"
              onClick={() => window.location.href = '/contact'}
            >
              Contact
            </span>
          </div>
          <div className="footer-column">
            <span className="footer-heading">Follow</span>
            <span className="footer-link">Tik Tok</span>
            <span className="footer-link">Instagram</span>
            <span className="footer-link">X</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer